// src/services/chatService.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const getAuthHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
});

export const chatService = {

  // ── Salons ────────────────────────────────────────────────────────────────

  getRooms: async () => {
    const r = await axios.get(`${API_BASE}/chat/rooms`, getAuthHeader());
    return r.data;
  },

  createRoom: async (roomData) => {
    const r = await axios.post(`${API_BASE}/chat/rooms`, {
      room_name: roomData.name,
      description: roomData.description,
      room_type: roomData.type,
      members: roomData.members
    }, getAuthHeader());
    return r.data;
  },

  deleteRoom: async (roomId) => {
    const r = await axios.delete(`${API_BASE}/chat/rooms/${roomId}`, getAuthHeader());
    return r.data;
  },

  joinRoom: async (roomId) => {
    const r = await axios.post(`${API_BASE}/chat/rooms/${roomId}/join`, {}, getAuthHeader());
    return r.data;
  },

  // ── Membres ───────────────────────────────────────────────────────────────

  getRoomMembers: async (roomId) => {
    const r = await axios.get(`${API_BASE}/chat/rooms/${roomId}/members`, getAuthHeader());
    return r.data;
  },

  addRoomMember: async (roomId, staffId) => {
    const r = await axios.post(`${API_BASE}/chat/rooms/${roomId}/members`,
      { staff_id: staffId }, getAuthHeader());
    return r.data;
  },

  removeRoomMember: async (roomId, staffId) => {
    const r = await axios.delete(`${API_BASE}/chat/rooms/${roomId}/members/${staffId}`, getAuthHeader());
    return r.data;
  },

  // ── Messages ──────────────────────────────────────────────────────────────

  getMessages: async (roomId, limit = 100, before = null) => {
    let url = `${API_BASE}/chat/messages/${roomId}?limit=${limit}`;
    if (before) url += `&before=${before}`;
    const r = await axios.get(url, getAuthHeader());
    return r.data;
  },

  sendMessage: async (roomId, message, type = 'text', metadata = null) => {
    const payload = { message, type };
    if (metadata) payload.metadata = metadata;
    const r = await axios.post(`${API_BASE}/chat/messages/${roomId}`, payload, getAuthHeader());
    return r.data;
  },

  // ── Upload photo ──────────────────────────────────────────────────────────

  uploadPhoto: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const r = await axios.post(`${API_BASE}/upload/photo`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return r.data;
  },

  sendPhoto: async (roomId, photoUrl) => {
    const r = await axios.post(`${API_BASE}/chat/messages/${roomId}`,
      { message: photoUrl, type: 'image', url: photoUrl }, getAuthHeader());
    return r.data;
  },

  // ── Données de référence pour formulaire RDV ──────────────────────────────

  getRefAircraft: async () => {
    const r = await axios.get(`${API_BASE}/chat/ref/aircraft`, getAuthHeader());
    return r.data;
  },

  getRefOwners: async () => {
    const r = await axios.get(`${API_BASE}/chat/ref/owners`, getAuthHeader());
    return r.data;
  },

  getRefHangars: async () => {
    const r = await axios.get(`${API_BASE}/chat/ref/hangars`, getAuthHeader());
    return r.data;
  },

  getRefStaff: async () => {
    const r = await axios.get(`${API_BASE}/chat/ref/staff`, getAuthHeader());
    return r.data;
  },

  // ── RDV ───────────────────────────────────────────────────────────────────

  sendAppointmentRequest: async (roomId, appointmentData) => {
    const r = await axios.post(`${API_BASE}/chat/messages/${roomId}`, {
      message: `📅 Demande de RDV : ${appointmentData.title}`,
      type: 'appointment_request',
      metadata: appointmentData
    }, getAuthHeader());
    return r.data;
  },

  confirmAppointment: async (messageId, action, reason = '') => {
    const r = await axios.post(
      `${API_BASE}/chat/appointment/confirm/${messageId}`,
      { action, reason },
      getAuthHeader()
    );
    return r.data;
  },

  // ── WebSocket ─────────────────────────────────────────────────────────────

  connectWebSocket: (roomId, userId, onMessage) => {
    const ws = new WebSocket(`ws://localhost:8001/chat/ws/${roomId}?user_id=${userId}`);
    ws.onopen = () => console.log(`Connected to room: ${roomId}`);
    ws.onmessage = (event) => { const data = JSON.parse(event.data); onMessage(data); };
    ws.onerror = (error) => console.error('WebSocket error:', error);
    ws.onclose = () => console.log(`Disconnected from room: ${roomId}`);
    return ws;
  }
};